import axios from 'axios';
import { navigate } from 'gatsby';
import { API, APP } from 'gatsby-env-variables';

import helpers from 'utils/helpers';
import safeStorage from 'utils/storage/safeStorage';

import { checkTokenExpiration, setAuthInfo } from './helpers';

export const api = axios.create({
  baseURL: API.ROOT_API,
  headers: {
    App: APP.APP_KEY,
    TenantId: APP.TENANT_ID,
  },
});

// API Auth handler
api.interceptors.request.use(async function (requestConfig) {
  requestConfig.headers['X-Correlation-Id'] = helpers.random.uuid();

  const cryptoStore = await safeStorage();
  const sessionTokenStored = await cryptoStore?.get('session-token');

  const isNotAuthRequest = !requestConfig.isAuthRequest;

  const hasNotAuthInfoSetted = !sessionTokenStored && isNotAuthRequest;
  const hasAuthInfoSetted = sessionTokenStored && isNotAuthRequest;

  if (hasNotAuthInfoSetted) {
    return setAuthInfo({ api, cryptoStore, requestConfig });
  }

  if (hasAuthInfoSetted) {
    return checkTokenExpiration({
      api,
      cryptoStore,
      requestConfig,
      sessionTokenStored,
    });
  }

  return requestConfig;
});

// API Error handler
api.interceptors.response.use(
  // Status code 2xx (success)
  function (response) {
    return response;
  },
  function (error) {
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.message === 'Proposta já processada'
    ) {
      navigate('/');
      return;
    }

    if (
      error?.response?.status >= 403 &&
      (error?.response?.data?.message === 'maintenance' ||
        error?.response?.data?.message === 'suspicious activity detected')
    ) {
      navigate('/sistema-indisponivel');
      return;
    }

    // Status code 4xx (client error)
    if (error?.response?.status >= 400 && error?.response?.status < 500) {
      return { data: error?.response?.data?.message, error: true };
    }
    // Status code 5xx (server error)
    if (error?.response?.status >= 500) {
      navigate('/erro');
      return;
    }

    return Promise.reject(error);
  },
);
